import type { ReactNode } from "react"

import { Button } from "@/components/ui/button"
import type { Nav } from "@/lib/hooks"

export function DetailShell({
  title,
  backTo,
  nav,
  data,
  err,
  children,
}: {
  title: ReactNode
  backTo: string
  nav: Nav
  data: unknown
  err?: string
  children: ReactNode
}) {
  return (
    <div className="mx-auto my-6 max-w-4xl space-y-6 border-l border-dotted py-2 pr-4 pl-7">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          if (history.state?.inApp) history.back()
          else nav(backTo)
        }}
      >
        ← Back
      </Button>
      {err && <p className="text-sm text-red-600">{err}</p>}
      {!err && !data && <p className="text-sm text-muted-foreground">Loading…</p>}
      {data != null && (
        <>
          <h1 className="text-base font-medium">{title}</h1>
          {children}
        </>
      )}
    </div>
  )
}
